import "./Footer.css";
import React, {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import useTheme from "../../ThemeProvider.ts";

function Footer() {
  const { t } = useTranslation();

  const theme = useTheme();

  const ul = useRef(null);

  useEffect(() => {
    function updateWrappedClass() {
      const lines = new Map();
      [...ul.current.children].forEach(li => li.classList.remove("wrapped"));

      [...ul.current.children].forEach(li => {
        const top = li.getBoundingClientRect().top;

        if (!lines.has(top)) {
          lines.set(top, []);
        }
        lines.get(top).push(li);
      });

      const lineTops = [...lines.keys()].sort((a, b) => a - b);

      for (let i = 1; i < lineTops.length; i++) {
        const thisLine = lines.get(lineTops[i]);
        if (thisLine && thisLine.length > 0) {
          thisLine[0].classList.add("wrapped");
        }
      }
    }

    let timeout;
    timeout = setTimeout(updateWrappedClass, 500);
    window.addEventListener("resize", updateWrappedClass);

    return () => {
      window.removeEventListener("load", updateWrappedClass);
      window.removeEventListener("resize", updateWrappedClass);
      clearTimeout(timeout);
    }
  }, []);

  return (
      <footer className={"footer-container"}>
        <div className={'footer-wrapper'}>
          <div className={"footer-upper-wrapper"}>
            <img src={'images/ant1Logo.png'} alt="ant1 logo" loading="lazy" decoding="async" width="171" height="72" className={'footer-logo'}/>
            <div className={"footer-upper-social"}>
              <a href={'https://www.youtube.com/channel/UCGCzXaMVL_GQFZJFVOZ_Ppg'}>
                <img src="images/footer/v2/youtube.svg" alt="Youtube icon" loading="lazy" decoding="async" width="25" height="24"/>
              </a>
              <a href={'https://x.com/Ant1_plus'}>
                <img src="images/footer/v2/x.svg" alt="X icon" loading="lazy" decoding="async" width="25" height="24"/>
              </a>
              <a href={'https://www.instagram.com/ant1plus_official/'}>
                <img src="images/footer/v2/instagram.svg" alt="Instagram icon" loading="lazy" decoding="async" width="25" height="24"/>
              </a>
              <a href={'https://www.facebook.com/ANT1plus/'}>
                <img src="images/footer/v2/facebook.svg" alt="Facebook icon" loading="lazy" decoding="async" width="25" height="24"/>
              </a>
              <a href={'https://www.tiktok.com/@ant1plus'}>
                <img src="images/footer/v2/tiktok.svg" alt="Tiktok icon" loading="lazy" decoding="async" width="25" height="24"/>
              </a>
            </div>
          </div>
          <ul ref={ul}>
            <li>
              <a href={'https://help.antennaplus.gr/kb/τι-είναι-το-αντ1/'}>
                {t("footerAboutUs")}
              </a>
            </li>
            <li>
              <a onClick={()=>window.__tcfapi('displayConsentUi', 2, function () {
              })}>
                {t("footerPrivacyPolicy")}
              </a>
            </li>
            <li>
              <a href={theme.uris.other.termsAndConditions}>
                {t("footerTermsAndConditions")}
              </a>
            </li>
            <li>
              <a href={'https://help.antennaplus.gr/kb/privacy-cookies/'}>
                {t("footerPrivacyCookies")}
              </a>
            </li>
            <li>
              <a href={'https://help.antennaplus.gr/contact-us/'}>
                {t("footerContactUs")}
              </a>
            </li>
            <li>
              <a href={'https://help.antennaplus.gr/'}>
                {t("footerHelpCenter")}
              </a>
            </li>
          </ul>
        </div>
      </footer>);
}

export default Footer;
